import {
  startOfMonth,
  endOfMonth,
  startOfYear,
  startOfWeek,
  subWeeks,
  subMonths,
  endOfWeek,
  subDays,
} from 'date-fns'
import { range } from 'lodash'

import { PeriodRangeDate, PeriodRangeString } from '../../store/types'

import { DateShortcut, DefaultDateShortcutKey } from './types'

export const years = range(2015, new Date().getFullYear() + 1, 1)

export const intervalShortcuts: Record<DefaultDateShortcutKey, DateShortcut> = {
  allTime: {
    title: 'datePicker.shortcuts.allTime',
    startDate: null,
    endDate: null,
  },
  yesterday: {
    title: 'datePicker.shortcuts.yesterday',
    startDate: subDays(new Date(), 1),
    endDate: subDays(new Date(), 1),
  },
  today: {
    title: 'datePicker.shortcuts.today',
    startDate: new Date(),
    endDate: new Date(),
  },
  lastWeek: {
    title: 'datePicker.shortcuts.lastWeek',
    startDate: startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), // Monday
    endDate: endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), // Sunday
  },
  monthToDate: {
    title: 'datePicker.shortcuts.monthToDate',
    startDate: startOfMonth(new Date()),
    endDate: new Date(),
  },
  prevMonth: {
    title: 'datePicker.shortcuts.lastMonth',
    startDate: startOfMonth(subMonths(new Date(), 1)),
    endDate: endOfMonth(subMonths(new Date(), 1)),
  },
  yearToDate: {
    title: 'datePicker.shortcuts.yearToDate',
    startDate: startOfYear(new Date()),
    endDate: new Date(),
  },
}

export const toPeriodRangeString = ([start, end]: PeriodRangeDate): PeriodRangeString => [
  start ? start.toISOString() : null,
  end ? end.toISOString() : null,
]

export const toPeriodRangeDate = ([start, end]: PeriodRangeString): PeriodRangeDate => [
  start ? new Date(start) : null,
  end ? new Date(end) : null,
]
